import Vue from 'vue'
import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const PermissionState = {
  permissions: [],
}

export const PermissionActions = {
  async reloadPermissions ({ commit, rootState }) {
    return axiosRequest.get('/calendar/permissions', {
      params: {
        user_id: rootState.currentUser.id,
      },
    }).
      then(({ data }) => commit('setPermissions', data.map(p => {
        return {
          enabled: p.enabled,
          fromUserId: p.from_user_id,
          permission: p.permission,
          toUserId: p.to_user_id,
        }
      }))).
      catch(handleError)
  },

  async setPermission ({ commit }, { fromUserId, toUserId, permission, enabled }) {
    return axiosRequest.put('/calendar/permissions/', {
      from_user_id: fromUserId,
      to_user_id: toUserId,
      permission,
      enabled,
    }).
      then(({ data }) => {
        commit('setPermission', {
          enabled: data.enabled,
          fromUserId: data.from_user_id,
          permission: data.permission,
          toUserId: data.to_user_id,
        })
      }).
      catch(handleError)
  },

  async removeAllPermissions ({ commit }, { fromUserId, toUserId }) {
    return axiosRequest.delete('/calendar/permissions', {
      params: {
        from_user_id: fromUserId,
        to_user_id: toUserId,
      },
    }).
      then(_ => commit('removeAllPermissions', { fromUserId, toUserId })).
      catch(handleError)
  },
}

export const PermissionMutations = {
  setPermission: (state, { enabled, fromUserId, permission, toUserId }) => {
    const index = state.permissions.findIndex(gp => {
      return gp.fromUserId === fromUserId &&
             gp.permission === permission &&
             gp.toUserId === toUserId
    })

    if (index < 0) {
      state.permissions.push({
        enabled,
        fromUserId,
        permission,
        toUserId,
      })
    } else {
      state.permissions[index].enabled = enabled
    }
  },

  setPermissions: (state, permissions) => {
    Vue.set(state, 'permissions', permissions)
  },

  removeAllPermissions: (state, { fromUserId, toUserId }) => {
    const filteredPermissions = state.permissions.filter(p => {
      return p.fromUserId !== fromUserId || p.toUserId !== toUserId
    })

    Vue.set(state, 'permissions', filteredPermissions)
  },
}

export const PermissionGetters = {
  receivedPermissions: state => userId => state.permissions.filter(p => p.toUserId === userId && p.enabled),

  receivedPermissionFrom: state => (userId, permission) => {
    return !!state.permissions.find(p => p.fromUserId === userId && p.permission === permission && p.enabled)
  },

  receivedPermissionsFrom: state => userId => {
    return state.permissions.filter(p => p.fromUserId === userId && p.enabled)
  },

  receivedPermissionsFor: state => (userId, permission) => {
    return state.permissions.filter(p => p.toUserId === userId && p.permission === permission && p.enabled)
  },

  givenPermissions: state => userId => state.permissions.filter(p => p.fromUserId === userId && p.enabled),

  givenPermissionsFor: state => (userId, permission) => {
    return state.permissions.filter(p => p.toUserId === userId && p.permission === permission && p.enabled)
  },
}
